import Hero from '../components/sections/Hero';
import StatsStrip from '../components/sections/StatsStrip';
import Capabilities from '../components/sections/Capabilities';
import ServicesGrid from '../components/sections/ServicesGrid';
import TechStack from '../components/sections/TechStack';
import BlogTeaser from '../components/sections/BlogTeaser';
import CtaBand from '../components/sections/CtaBand';
import { useJsonLd, siteOrigin } from '../lib/seo';

export default function HomePage() {
    const origin = siteOrigin();
    // WebPage schema for the home page (Organization + WebSite are already in index.html)
    useJsonLd('home-page', {
        '@context': 'https://schema.org',
        '@type': 'WebPage',
        '@id': `${origin}/#webpage`,
        url: `${origin}/`,
        name: 'DigiTech Cloud AI · Advanced Software, AI & Cloud for Africa & the World',
        description: 'Senior-led software engineering, applied AI, cloud, cybersecurity, and digital transformation for governments, enterprises, and ambitious ventures — rooted in Africa, delivering globally.',
        isPartOf: { '@id': `${origin}/#website` },
        about: { '@id': `${origin}/#organization` },
        inLanguage: 'en',
        primaryImageOfPage: {
            '@type': 'ImageObject',
            url: 'https://images.unsplash.com/photo-1451187580459-43490279c0fa?auto=format&fit=crop&w=1200&h=630&q=80',
        },
    });
    return (
        <div data-testid="home-page">
            <Hero />
            <StatsStrip />
            <Capabilities />
            <ServicesGrid />
            <TechStack />
            <BlogTeaser />
            <CtaBand />
        </div>
    );
}
